import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';
import { withTranslation } from 'react-i18next';
import 'css/selector-dropdown.css';
import './style.css';

class ScriptsDropdown extends Component {
  handleScriptClick = function(index) {
    this.props.onScriptClick(index);
    this.props.onClose();
  };

  handleCreateClick = function() {
    this.props.onClose();
    if (this.props.onCreateClick) {
      this.props.onCreateClick();
    }
  };

  render() {
    var _this = this;
    var props = this.props;
    var open = props.open;
    var anchorEl = props.anchorEl;
    var onClose = props.onClose;
    var scripts = props.scripts;
    var activeIndex = props.activeIndex;
    var t = props.t;

    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onRequestClose={onClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        className="selector-dropdown-popover"
        zDepth={0}
        style={{
          marginTop: 8,
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          borderRadius: 12,
        }}
      >
        <div className="selector-dropdown" style={{ minWidth: 220 }}>
          <div className="selector-dropdown-header" style={{ justifyContent: 'flex-end' }}>
            <button
              className="selector-create-btn"
              onClick={function() { _this.handleCreateClick(); }}
            >
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
              {t('scripts:createScript')}
            </button>
          </div>

          <div className="selector-dropdown-content">
            {scripts.length > 0 ? (
              scripts.map(function(script, index) {
                return (
                  <button
                    key={script.uuid}
                    className={'scripts-dropdown-item' + (index === activeIndex ? ' scripts-dropdown-item-active' : '')}
                    onClick={function() { _this.handleScriptClick(index); }}
                  >
                    <div className="scripts-dropdown-item-inner">
                      <span className="scripts-dropdown-item-name">{script.name}</span>
                    </div>
                  </button>
                );
              })
            ) : (
              <div className="selector-dropdown-empty">
                No scripts yet
              </div>
            )}
          </div>
        </div>
      </Popover>
    );
  }
}

ScriptsDropdown.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  scripts: PropTypes.array.isRequired,
  activeIndex: PropTypes.number,
  onScriptClick: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ScriptsDropdown);
